import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import LoadingOverlay from "../UI/LoadingOverlay/LoadingOverlay";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, isUserInactive, isNavigating } =
    useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/auth", { replace: true });
    } else if (!loading && isAuthenticated && isUserInactive) {
      navigate("/access-denied?reason=account_disabled", { replace: true });
    }
  }, [isAuthenticated, loading, isUserInactive, navigate]);

  if (loading || isNavigating) {
    return (
      <LoadingOverlay
        isVisible={true}
        message={loading ? "Checking authentication..." : "Loading page..."}
        maxDisplayTime={loading ? 1000 : 300}
      />
    );
  }

  if (!isAuthenticated || isUserInactive) {
    return (
      <LoadingOverlay
        isVisible={true}
        message={
          !isAuthenticated
            ? "Redirecting to login..."
            : "Redirecting to access denied..."
        }
        maxDisplayTime={500}
      />
    );
  }

  return children;
}
